<template>
    <v-card
        tile
        flat
        class="balanceCard"
        :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
    >
        <v-container>
            <v-row dense>
                <v-col cols="12">
                    <v-sheet
                        class="d-flex mb-0"
                        :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
                    >
                        <div class="title">
                            <v-icon dense color="#5F7692"
                                >mdi-bag-checked</v-icon
                            >
                            <span class="ml-2">My Investor Wallet Balance</span>
                            <p class="number mb-0">
                                {{ Number(mam_wallet_summary?.mamWalletHistory?.investor_available_balance || 0).toFixed(2) }}
                                <strong>USD</strong>
                            </p>
                        </div>
                        <v-spacer></v-spacer>
                        <div class="title">
                            <v-icon dense color="#5F7692"
                                >mdi-bag-checked</v-icon
                            >
                            <span class="ml-2">My Manager Wallet Balance</span>
                            <p class="number mb-0">
                                {{ Number(mam_wallet_summary?.mamWalletHistory?.manager_available_balance || 0).toFixed(2) }}
                                <strong>USD</strong>
                            </p>
                        </div>
                        <!-- <p class="mb-0 profit-info">
                            Profit:
                            <strong
                                >{{
                                    mam_wallet_summary?.mamWalletHistory.manager_total_earning?.toFixed(2) ||
                                    0
                                }}
                                USD</strong
                            >
                        </p> -->
                    </v-sheet>
                </v-col>
                <v-col cols="12">
                    <v-card-text
                        class="d-flex pl-0 pb-2 pr-0 trade align-center"
                    >
                        <p class="equity">
                            Investor Total Earning:
                            {{ Number(mam_wallet_summary?.mamWalletHistory?.investor_total_earning || 0).toFixed(2) }} USD
                            <br />Investor Total Withdraw:
                            {{ Number(mam_wallet_summary?.mamWalletHistory?.investor_total_withdraw || 0).toFixed(2) }} USD
                        </p>
                        <v-spacer></v-spacer>
                        <p class="equity text-right">
                            Manager Total Earning:
                            {{ Number(mam_wallet_summary?.mamWalletHistory?.manager_total_earning || 0).toFixed(2) }} USD
                            <br />Manager Total Withdraw:
                            {{ Number(mam_wallet_summary?.mamWalletHistory?.manager_total_withdraw || 0).toFixed(2) }} USD
                        </p>
                    </v-card-text>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import { MAM__WALLET__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
    name: "balanceCard",
    components: {},
    data() {
        return {};
    },

    computed: {
        ...mapState("mamWallet", ["mam_wallet_summary"]),
    },

    methods: {
        ...mapActions("mamWallet", [MAM__WALLET__ACTIONS.USERMAMWALLETSUMMARY]),
    },

    async mounted() {
        try {
            await this[MAM__WALLET__ACTIONS.USERMAMWALLETSUMMARY]();
        } catch (error) {
            console.log(error);
        }
    },
};
</script>
